import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
// Entities
import { Company } from "@/entities/index";

@Component
export default class ChangeClient extends Vue {
  clients: Company[] = [];

  goOtherClient(code: string) {
    switch (code) {
      case "SPF":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_SPF,
          "_blank"
        );
        break;
      case "NOK":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_NOK,
          "_blank"
        );
        break;
      case "APO":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_APO,
          "_blank"
        );
        break;
      case "ALPA":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_ALPA,
          "_blank"
        );
        break;
      case "PFO":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_PFO,
          "_blank"
        );
        break;
      case "CAP":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_CAP,
          "_blank"
        );
        break;
      case "MAY":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_MAY,
          "_blank"
        );
        break;
      case "LPB":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_LPB,
          "_blank"
        );
        break;
      case "KUMHO":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_KUMHO,
          "_blank"
        );
        break;
      case "VDB":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_VDB,
          "_blank"
        );
        break;
      case "CMJ":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_CMJ,
          "_blank"
        );
        break;
      case "LOVELY":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_LOVELY,
          "_blank"
        );
        break;
      case "EURO":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_EURO,
          "_blank"
        );
        break;
      case "GRU":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_GRU,
          "_blank"
        );
        break;
      case "MFB":
        window.open(
          "https://logone.tempo-one.com/connect?uuid=" +
            process.env.VUE_APP_MFB,
          "_blank"
        );
        break;
      default:
        break;
    }
  }

  async allClients(): Promise<void> {
    this.clients = (await axios.get(`/api/companies`)).data as Company[];
  }

  mounted() {
    this.allClients();
  }
}
